'use strict';
const angular = require('angular');

export class scheduleViewComponent {

  scheduleTypes = {
    'Three Panel MF': {
      class: 'col-xs-12 col-sm-6 col-lg-4',
      sections: [
        {days: [1, 2, 3, 4, 5], title: 'Monday-Friday'},
        {days: [6], title: 'Saturday'},
        {days: [0], title: 'Sunday'}]
    },
    'Three Panel': {
      class: 'col-xs-12 col-sm-6 col-lg-4',
      sections: [
        {days: [1, 2, 3, 4], title: 'Monday-Thursday'},
        {days: [5], title: 'Friday'},
        {days: [6, 0], title: 'Saturday-Sunday'}]
    },
    'Four Panel': {
      class: 'col-sm-6',
      sections: [
        {days: [1, 2, 3, 4], title: 'Monday-Thursday'},
        {days: [5], title: 'Friday'},
        {days: [6], title: 'Saturday'},
        {days: [0], title: 'Sunday'}]
    }
  }

  departing = ['BS', 'FI']

  /*@ngInject*/
  constructor() {
    this.dayKey = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    this.message = 'World';
  }

  deleteTime(line, days) {
    // console.log(days);
    // console.log(line);
    this.removeTime({line, days});
  }

  dayCheck(line, days) {
    let days1 = days.days;
    let days2 = line.days;
    if(days1.every(elem => days2.indexOf(elem) > -1)) {
      return false;
    } else {
      return 'Only';
    }
  }

  onlyDays(line, days) {
    // console.log('Only Days');
    let days1 = days.days;
    let days2 = line.days;

    let out = '';

    for(let i = 0; i < days2.length; i++) {
      let day = days2[i];
      // console.log(day);
      if(days1.indexOf(day) > -1) {
        let newDay = this.dayKey[day].charAt(0).toUpperCase() + this.dayKey[day].substr(1, 2).toLowerCase();
        // console.log('new:', newDay);
        if(out === '') {
          out = newDay;
        } else {
          out = `${out} & ${newDay}`;
        }
      }
    }

    out = `${out} only`;
    return out;
  }

}

export default angular.module('fiapiApp.scheduleView', [])
  .component('scheduleView', {
    template: require('./scheduleView.pug'),
    bindings: { schedule: '<', removeTime: '&', mode: '@'},
    controller: scheduleViewComponent
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/scheduleView/scheduleView.component.js